<div class="no-time-log" fxLayout="column" fxLayoutAlign="center center">
    <img src="../../../../assets/image/svg/no-time-log.svg" width="178px">
    <div class="title" *ngIf="config.title">{{config.title}}</div>
    <div class="title-small" *ngIf="config.description">{{config.description}}</div>
    <button class="add-time-log" *ngIf="config.isShowButton" (click)="buttonClicked()">{{config.buttonText}}</button>
</div>
